import * as React from 'react';
import { Link } from 'react-router-dom';
import { currentUserStore } from '../../../../../../CurrentUserStore';
import { findLink } from '../../../../../../LinkyLinky';
import { T } from '../../../../../../Translations';
import { Maybe } from 'maybeasy';

export interface Props {
  id: number;
}

// DVLP-7601: gate on `preview-learning-collection-v2` — the backend emits it
// for every user with `show?` on learning collections. The legacy P3 iframe
// preview was removed because it went blank on license-optional collections
// after the DVLP-7538 UPL entitlement inversion.
export const previewLink = ({ id }: Props): Maybe<React.ReactNode> =>
  findLink('preview-learning-collection-v2', currentUserStore.links).map(() => (
    <Link
      key="preview-learning-collection-v2"
      to={`/learning_collections/${id}/preview`}
      className="px-4 py-2.5"
      target="_blank"
      rel="noopener noreferrer"
      data-intercom-target="preview-collection-action"
    >
      <T kind="Preview" />
    </Link>
  ));
